export default __webpack_public_path__ + "static/media/l-4.c50777a9.png";